import { useEffect } from 'react';

import { analytics } from 'analytics';
import { closePopupWindow } from 'utils/popup';

import FullPageSpinner from '../components/FullPageSpinner';
import { useApiContext } from '../contexts/apiContext';
import { msalInstance, msalRequest } from '../utils/addin/auth';

const SignInMicrosoftRedirectPage: React.FC = () => {
  const { api } = useApiContext();

  // Once the auth script is initialized, redirect to Microsoft sign in page, which will
  // redirect back to this page with the access token. Then use that token to sign into
  // our app and close this window on success..
  // See https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/initialization.md#redirect-apis
  useEffect(() => {
    const handleAuthentication = async () => {
      try {
        await msalInstance.initialize();
        const res = await msalInstance.handleRedirectPromise();
        if (res) {
          const socialLoginRequest = { access_token: res.accessToken };
          await api().currentUser.signInViaMicrosoft({ socialLoginRequest });
          closePopupWindow();
        } else {
          await msalInstance.loginRedirect(msalRequest);
        }
      } catch (error: any) {
        // Don't report errors when user denies consent (access_denied)
        if (error?.errorCode !== 'access_denied') {
          analytics.reportError('Error signing in with Microsoft', { error });
        }
        // Always close the popup window on error
        closePopupWindow();
      }
    };
    handleAuthentication();
  }, []);

  return <FullPageSpinner />;
};

export default SignInMicrosoftRedirectPage;
